import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message.
 * Supports two call styles:
 *   useAlert('message')                                    — direct call
 *   const { showAlert } = useAlert(); showAlert('message') — composable style
 */
export const useAlert = (message, action = null) => {
  const showAlert = (msg, act = null) => {
    emitter.emit('newToastMessage', { message: msg, action: act });
  };
  if (message !== undefined) {
    showAlert(message, action);
  }
  return { showAlert };
};
